import { render, staticRenderFns } from "./curve-change.vue?vue&type=template&id=813875ea&scoped=true"
import script from "./curve-change.vue?vue&type=script&lang=js"
export * from "./curve-change.vue?vue&type=script&lang=js"
import style0 from "./curve-change.vue?vue&type=style&index=0&id=813875ea&prod&lang=less&scoped=true"
import style1 from "./curve-change.vue?vue&type=style&index=1&id=813875ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813875ea",
  null
  
)

export default component.exports